/**
 * @generated SignedSource<<90438d91ffb7119588e15ea9712e0155>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildPresentationsScreenUpcomingPresentationsSection_guild$data = {
  readonly id: string;
  readonly upcomingPresentations: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"PresentationItemNew_presentation">;
      };
    }>;
  };
  readonly " $fragmentType": "GuildPresentationsScreenUpcomingPresentationsSection_guild";
};
export type GuildPresentationsScreenUpcomingPresentationsSection_guild$key = {
  readonly " $data"?: GuildPresentationsScreenUpcomingPresentationsSection_guild$data;
  readonly " $fragmentSpreads": FragmentRefs<"GuildPresentationsScreenUpcomingPresentationsSection_guild">;
};

import GuildPresentationsScreenUpcomingPresentationsSectionPaginationQuery_graphql from './GuildPresentationsScreenUpcomingPresentationsSectionPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "upcomingPresentations"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 3,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": GuildPresentationsScreenUpcomingPresentationsSectionPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "GuildPresentationsScreenUpcomingPresentationsSection_guild",
  "selections": [
    {
      "alias": "upcomingPresentations",
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "CREATED_AT_DESC",
            "ID_ASC"
          ]
        },
        {
          "kind": "Literal",
          "name": "timeSelection",
          "value": "UPCOMING"
        }
      ],
      "concreteType": "PresentationsConnection",
      "kind": "LinkedField",
      "name": "__GuildPresentationsScreenUpcomingPresentationsSection_guild_upcomingPresentations_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PresentationsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Presentation",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PresentationItemNew_presentation"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__GuildPresentationsScreenUpcomingPresentationsSection_guild_upcomingPresentations_connection(orderBy:[\"CREATED_AT_DESC\",\"ID_ASC\"],timeSelection:\"UPCOMING\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Guild",
  "abstractKey": null
};
})();

(node as any).hash = "46692bcb9277ab438e87a9359e60422b";

export default node;
